import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { User} from "../_models/user";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import {errorObject} from "rxjs/util/errorObject";
import * as Endpoints from '../endpoints';

@Injectable()
export class AuthenticationService {

  public sessionStorage: Storage;


  constructor(private http: HttpClient) {

    if (typeof(Storage) !== "undefined") {
      this.sessionStorage = window.sessionStorage;
    }
    else {
      this.sessionStorage = null;
    }

  }


  getSessionItem(key: string): any {
    if (this.sessionStorage != null) {
      return this.sessionStorage.getItem(key);
    }
    else {
      return null;
    }
  }


  /**
   * There is not currently provided any token service. It will be implemented in first phase though.
   * Also server names will be configurable, of course.
   * @param {string} username
   * @param {string} password
   * @returns {Observable<any>}
   */


  login(username: string, password: string) {
    console.debug("username is "+username);
    let u = new User();
    u.username=username;
    u.password=password;
    return this.http.post<any>(Endpoints.AUTHENTICATION_ENDPOINT, JSON.stringify(u))
      .map(user => {
        // login successful if there's a jwt token in the response
        if (user.userRole=='admin') {
          this.setAuthenticated(user.accessToken);
          return user;
        }
        else {
          let unauthenticated=new User();
          unauthenticated.userRole='unauthenticated';
        }
       });
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this.sessionStorage.removeItem('authenticated');
    this.setUnAuthenticated();
  }

  removeSessionItem(key: string) {
    if (this.sessionStorage != null) {
      this.sessionStorage.removeItem(key);
    }
  }

  /**
   * This will be improved with JWT later.
   */


  setAuthenticated(accessToken: string){
    this.setSessionItem("authenticated", "true");
    localStorage.setItem("accessToken", accessToken);
    this.setSessionItem("accessToken", accessToken)
  }

  setUnAuthenticated(){
    this.removeSessionItem("authenticated");
    localStorage.removeItem("accessToken");
    this.removeSessionItem("accessToken");
  }

  isAuthenticated(){
    if (this.getSessionItem("authenticated")=="true"){
      return true;
    }
    return false;
  }

  setSessionItem(key:string, value: string) {
    if (this.sessionStorage != null) {
      this.sessionStorage.setItem(key, value);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts